export const API_CONFIG = {
    HOSTNAME: `${window.location.protocol}//${window.location.hostname}`,
    API_PREFIX: '/api',
    API_VERSION: '/v1',
    API_AUTH: '/auth'
};